import React from "react";
import { UserContext } from "../UserContext";
import { withRouter } from "../utils/withRouter";

class PublicRouteResetUser extends React.Component {
  static contextType = UserContext;

  componentDidMount() {
    this.resetIfOnPublicRoute();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.resetIfOnPublicRoute();
    }
  }

  resetIfOnPublicRoute = () => {
    const { isLoggedIn, logout } = this.context;
    const { location } = this.props;

    const publicRoutes = ["/", "/forgot-password", "/reset-password"];
    const isPublic = publicRoutes.includes(location.pathname);


    if (isPublic && isLoggedIn) {
      logout();
    }
  };

  render() {
    return this.props.children;
  }
}

export default withRouter(PublicRouteResetUser);